
    const data = {"name":"src/core/icons/close-circle","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12 6.47 2 12 2m3.59 5L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41 15.59 7Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            